import {
  Box,
  Button,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import DateSelectionPopover from "./date-selection-popover";
import { useState } from "react";
import moment from "moment";

const DatesFilter = ({ onChange, values }: { onChange: any; values: any }) => {
  const [anchorEl, setAnchorEl] = useState<any | null>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Box
        sx={{
          border: "1px solid #E2E2E2",
          borderRadius: "10px",
          px: "20px",
          py: "10px",
          flex: 1,
          // width: {
          //   md: "200px",
          //   lg: "200px",
          //   xl: "300px",
          //   sm: "300px",
          //   xs: "300px",
          // },
        }}
        id="basic-button"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Typography
          sx={{
            color: "#383838",
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "22px",
            fontFamily: "Inter",
          }}
        >
          Date
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "15px",
              lineHeight: "24px",
              color: !values?.start ? "rgb(162, 162, 162)" : "",
            }}
          >
            {values?.start
              ? moment(values.start).format("MMM DD")
              : "Start date"}{" "}
            - {values?.end ? moment(values.end).format("MMM DD") : "End date"}
          </Typography>
          <img
            src="/assets/img/icons/calendar_search.svg"
            height="24"
            width="24"
            alt="Calendar Search"
          />
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: { borderRadius: "10px" },
        }}
      >
        <DateSelectionPopover handleClose={handleClose} onChange={onChange} />
      </Menu>
    </div>
  );
};

export default DatesFilter;
